/**
 * @generated SignedSource<<9861da9d73f7af6bbf761d0654d5b412>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRefineMenuClose_appliedFilters$data = ReadonlyArray<{
  readonly name: string | null;
  readonly values: ReadonlyArray<{
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "useRefineMenuClose_appliedFilters";
}>;
export type useRefineMenuClose_appliedFilters$key = ReadonlyArray<{
  readonly " $data"?: useRefineMenuClose_appliedFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRefineMenuClose_appliedFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useRefineMenuClose_appliedFilters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParamValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseParsedParam",
  "abstractKey": null
};

(node as any).hash = "7d44e537cd0d08dae6774109d170a3d2";

export default node;
